import { defineComponent, h } from 'vue';
import { Dialog } from '@phi/components';
import { refresh_model } from '@frontend/input_output';

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': x => this.$emit('update:show', x),
            onClose: () => this.$emit('update:show', false),
            close_label: 'Cancel',
            confirm_label: 'Restart',
            onConfirm: () => {
                this.$emit('update:show', false);
                refresh_model();
            },
            id: 'refreshModal',
            title: 'Restart model',
        }, () => h('p', 'You are about to start a new model. Are you sure?'));
    }
});
